module.exports = __webpack_public_path__ + "static/media/brand.aa431488.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/categories/brand.svg
// module id = 270
// module chunks = 0